import * as React from "react";
import classNames from "../../../utilities/class-names";

export const SfSearchIcon = ({ className }) => {
    return <svg className={classNames('docs-icon', className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M14.809,15.357l-4.423-5.271C11.385,9.015,12,7.581,12,6c0-3.313-2.686-6-6-6C2.688,0,0,2.688,0,6 c0,3.314,2.688,6,6,6c1.373,0,2.633-0.466,3.645-1.24L14.042,16L14.809,15.357z M6,11c-2.762,0-5-2.24-5-5c0-2.761,2.238-5,5-5 s5,2.238,5,5C11,8.76,8.762,11,6,11z"/>
    </svg>;
}